import React from 'react'

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    variant?: 'default' | 'secondary' | 'outline'
}

export const Badge: React.FC<BadgeProps> = ({ variant = 'default', className = '', children, ...rest }) => {
    const base = 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium'
    const styles = {
        default: 'bg-blue-100 text-blue-800',
        secondary: 'bg-slate-100 text-slate-800',
        outline: 'border border-slate-300 text-slate-700'
    } as const

    return (
        <span className={`${base} ${styles[variant]} ${className}`} {...rest}>
            {children}
        </span>
    )
}

export default Badge






